// Normalização canónica dos estados do pedido.
// A API devolve valores inconsistentes entre versões
// ("Em preparo", "Preparando", "preparando", "Finalizado", "entregue"...).
// Todo o cliente deve passar por aqui para as cores/estados nunca "congelarem".

export type OrderStatusKey = "pendente" | "preparando" | "entregue" | "cancelado"

const ALIASES: Record<string, OrderStatusKey> = {
  pendente: "pendente",
  preparando: "preparando",
  "em preparo": "preparando",
  em_preparo: "preparando",
  empreparo: "preparando",
  pronto: "entregue",
  entregue: "entregue",
  finalizado: "entregue",
  concluido: "entregue",
  concluído: "entregue",
  cancelado: "cancelado",
}

export function normalizeOrderStatus(status: string | undefined | null): OrderStatusKey {
  if (!status) return "pendente"
  return ALIASES[status.trim().toLowerCase()] ?? "pendente"
}

export const ORDER_STATUS_META: Record<
  OrderStatusKey,
  { label: string; title: string; description: string; stepIndex: number }
> = {
  pendente: {
    label: "Pendente",
    title: "Pedido Recebido",
    description: "A cozinha já tem o teu pedido. Um instante...",
    stepIndex: 0,
  },
  preparando: {
    label: "Em preparo",
    title: "Em Preparo",
    description: "Os nossos chefs estão a preparar tudo com carinho.",
    stepIndex: 1,
  },
  entregue: {
    label: "Entregue",
    title: "Pedido Entregue",
    description: "O teu pedido foi entregue. Bom apetite!",
    stepIndex: 2,
  },
  cancelado: {
    label: "Cancelado",
    title: "Pedido Cancelado",
    description: "Fala connosco se precisares de ajuda.",
    stepIndex: -1,
  },
}

/** Passos do progresso visual (o cancelado não pertence à linha do tempo). */
export const ORDER_STEPS = [
  { key: "pendente", label: "Recebido" },
  { key: "preparando", label: "Em preparo" },
  { key: "entregue", label: "Entregue" },
] as const
